/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerRevokeSessionsMutationResponse, UserControllerRevokeSessionsPathParams, UserControllerRevokeSessionsQueryParams, UserControllerRevokeSessions403, UserControllerRevokeSessions404 } from "../../models/usersController/UserControllerRevokeSessions";

function getUserControllerRevokeSessionsUrl(userId: UserControllerRevokeSessionsPathParams["userId"]) {
  const res = { method: 'POST', url: `/api/v1/users/${userId}/sessions/revoke` as const }  
  return res
}

/**
 * @description Rejects every existing token for the user on its next use, signs them out of Cognito, revokes realtime tokens and expires their ProjectSight integrations within scope_id. Users may always revoke their own sessions; revoking another user requires admin rights over scope_id and the user must belong to it.
 * @summary Revoke all active sessions for a user
 * {@link /api/v1/users/:userId/sessions/revoke}
 */
export async function userControllerRevokeSessions(userId: UserControllerRevokeSessionsPathParams["userId"], params?: UserControllerRevokeSessionsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UserControllerRevokeSessionsMutationResponse, ResponseErrorConfig<UserControllerRevokeSessions403 | UserControllerRevokeSessions404>, unknown>({ method : "POST", url : getUserControllerRevokeSessionsUrl(userId).url.toString(), params, ... requestConfig })  
  return res.data
}